import App from './CalcPadApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iCalcPad', <App />);
